import _ from 'lodash';
import Submission from 'edge/quoteandbind/common/models/Submission';

export default ['$q', 'JsonRPCService', 'qnb.ErrorHandlingService', 'qnb.endpointConfig', 'qnb.xCenterRouteConfig', function ($q, JsonRPCService, ErrorHandlingService, endpointConfig, xCenterRouteConfig) {

    var xCenterRoute = xCenterRouteConfig;

    /**
     * @param {Object} params
     * @param {Object} params.submissionDTO
     * @param {String} params.processName
     * @param {Boolean} params.handleErrorBeforeRequest
     * @param {Boolean} params.setDTOBeforeHandling
     * @returns {Promise}
     */
    function processSubmission(params) {
        var submissionDTO = params.submissionDTO;
        var handleErrorBeforeRequest = params.handleErrorBeforeRequest;
        var setDTOBeforeHandling = params.setDTOBeforeHandling;

        var deferred = $q.defer();
        if (handleErrorBeforeRequest) {
            ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
        }

        var endpoint = endpointConfig.loadSaveEndpoint;
        JsonRPCService.send(xCenterRoute, endpoint, params.processName, [submissionDTO]).then(function (response) {
            if (!handleErrorBeforeRequest) {
                if (setDTOBeforeHandling) {
                    submissionDTO = new Submission(response);
                }
                ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
                if (!setDTOBeforeHandling) {
                    submissionDTO = new Submission(response);
                }
            } else {
                submissionDTO = new Submission(response);
            }
            return deferred.resolve(submissionDTO);
        }, handleError(deferred));
        return deferred.promise;
    }

    function setQuoteToDraft(quoteID, sessionUUID) {
        var deferred = $q.defer();
        var endpoint = endpointConfig.loadSaveEndpoint;
        JsonRPCService.send(xCenterRoute, endpoint, 'setQuoteToDraft', [quoteID, sessionUUID]).then(function (response) {
            ErrorHandlingService.checkSessionUUID({
                sessionUUID: sessionUUID
            }, deferred);
            var submissionDTO = new Submission(response);
            return deferred.resolve(submissionDTO);
        }, handleError(deferred));
        return deferred.promise;
    }

    function handleError(deferred) {
        return function (error, status, headers) {
            return deferred.reject([error, status, headers]);
        };
    }

    return {
        createSubmission: function createSubmission(submissionDTO) {
            return processSubmission({
                submissionDTO: submissionDTO,
                processName: 'create',
                handleErrorBeforeRequest: false,
                setDTOBeforeHandling: true
            });
        },
        saveAndQuoteSubmission: function saveAndQuoteSubmission(submissionDTO) {
            return processSubmission({
                submissionDTO: submissionDTO,
                processName: 'saveAndQuote',
                handleErrorBeforeRequest: false,
                setDTOBeforeHandling: false
            });
        },
        saveSubmission: function saveSubmission(submissionDTO) {
            var submissionParameters = {
                submissionDTO: submissionDTO,
                processName: 'updateDraftSubmission',
                handleErrorBeforeRequest: false,
                setDTOBeforeHandling: false
            };

            // Set quote to draft if in quoted state and then process sub
            if (submissionDTO.quoteData && _.some(submissionDTO.quoteData.offeredQuotes, function (quote) {
                return quote.status === 'Quoted';
            })) {
                var deferred = $q.defer();
                setQuoteToDraft(submissionDTO.quoteID, submissionDTO.sessionUUID).then(function () {
                    processSubmission(submissionParameters).then(function (updateResponse) {
                        deferred.resolve(updateResponse);
                    }, handleError(deferred));
                }, handleError(deferred));
                return deferred.promise;
            }

            return processSubmission(submissionParameters);
        },
        saveDraftSubmissionAndPrimaryLocation: function saveDraftSubmissionAndPrimaryLocation(submissionDTO) {
            var submissionParameters = {
                submissionDTO: submissionDTO,
                processName: 'updateDraftSubmissionAndPrimaryLocation',
                handleErrorBeforeRequest: false,
                setDTOBeforeHandling: false
            };

            if (submissionDTO.quoteData && _.some(submissionDTO.quoteData.offeredQuotes, function (quote) {
                return quote.status === 'Quoted';
            })) {
                var deferred = $q.defer();
                setQuoteToDraft(submissionDTO.quoteID, submissionDTO.sessionUUID).then(function () {
                    processSubmission(submissionParameters).then(function (updateResponse) {
                        deferred.resolve(updateResponse);
                    }, handleError(deferred));
                }, handleError(deferred));
                return deferred.promise;
            }
            return processSubmission(submissionParameters);
        },

        retrievePaymentPlans: function retrievePaymentPlans(submissionDTO) {
            var endpoint = endpointConfig.loadSaveEndpoint;
            return JsonRPCService.send(xCenterRoute, endpoint, 'retrievePaymentPlans', [submissionDTO.quoteID, submissionDTO.sessionUUID]);
        },
        quoteSubmission: function quoteSubmission(quoteID, sessionUUID) {
            var submissionDTO = void 0;
            var deferred = $q.defer();
            var endpoint = endpointConfig.loadSaveEndpoint;
            JsonRPCService.send(xCenterRoute, endpoint, 'quote', [quoteID, sessionUUID]).then(function (response) {
                ErrorHandlingService.checkSessionUUID({
                    sessionUUID: sessionUUID
                }, deferred);
                submissionDTO = new Submission(response);
                return deferred.resolve(submissionDTO);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        setQuoteToDraft: setQuoteToDraft,
        updateSubmissionCoverages: function updateSubmissionCoverages(quoteID, lobCoverages, sessionUUID) {
            var endpoint = endpointConfig.loadSaveEndpoint;
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateCoverages', [quoteID, sessionUUID, lobCoverages]);
        },
        saveQuotedSubmission: function saveQuotedSubmission(submissionDTO) {
            return processSubmission({
                submissionDTO: submissionDTO,
                processName: 'updateQuotedSubmission',
                handleErrorBeforeRequest: true,
                setDTOBeforeHandling: false
            });
        },
        bindSubmission: function bindSubmission(submissionDTO) {
            return processSubmission({
                submissionDTO: submissionDTO,
                processName: 'bind',
                handleErrorBeforeRequest: false,
                setDTOBeforeHandling: false
            });
        },
        retrieveSubmission: function retrieveSubmission(submissionDTO) {
            return processSubmission({
                submissionDTO: submissionDTO,
                processName: 'retrieve',
                handleErrorBeforeRequest: false,
                setDTOBeforeHandling: false
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/services/LoadSaveService.js
// module id = 859
// module chunks = 0